import React from 'react';

function Icon() {
  return (
    <svg width="41" height="31" fill="none" viewBox="0 0 41 31">
      <path
        fill="#4783FF"
        d="M13.213 24.272l-9.564-9.593L.46 17.877l12.752 12.79L40.539 3.26 37.35.062l-24.137 24.21z"></path>
    </svg>
  );
}

export default Icon;
